import template from './jobProgressViewTile.template.html';

export default {
  template,
  bindings: {
    job: '<',
    accounts: '<',
    tickets: '<',
    contacts: '<',
    onToggle: '&',
    onClick: '&'
  },
controller: class controller {
    constructor($rootScope, $mdMedia, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.currentTimeZone = null;
      ctrl.currentDateFormat = null;
      ctrl.currentTimeFormat = null;
      ctrl.$mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentTimeFormat = $rootScope.CurrentTimeFormat;
        ctrl.job = ctrl.job || {};
        ctrl.accounts = ctrl.accounts || [];
        ctrl.tickets = ctrl.tickets || [];
        ctrl.contacts = ctrl.contacts || [];
      };

      ctrl.toggle = (data) => {
        let canBeCompleted = true;
        if (data && data.items && data.items.length) {
          const len = data.items.length;
          for (let i = 0; i < len; i += 1) {
            if (!data.items[i].isActive) {
              canBeCompleted = false;
              break;
            }
          }
        }
        if (canBeCompleted) {
          ctrl.onToggle({ data });
        } else {
          uiService.toast({
            text: {
              p1: 'Not all sub-tasks',
              p2: 'have been',
              p3: 'completed'
            },
            warn: true
          });
        }
      };

      ctrl.click = ($event, data) => {
        ctrl.onClick({ event: $event, data });
      };

      ctrl.isJobProgressDoing = () =>
        ctrl.job.jobProgress ? ctrl.job.jobProgress.name === 'doing' : '';

      ctrl.getAccount = (idAccount) => _.find(ctrl.accounts, (a) => a.id === idAccount);

      ctrl.getTicket = (idTicket) => _.find(ctrl.tickets, (t) => t.id === idTicket);

      ctrl.getContact = (idContact) => _.find(ctrl.contacts, (c) => c.id === idContact);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (changes.jobs && changes.jobs.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
